class SplideComponent extends HTMLElement {
  constructor() {
    super();
    const perPage = this.dataset["perPage"] || 3;
    const pagination = this.dataset["pagination"] || false;
    const gap = this.dataset["gap"] || "1rem";
    new Splide(this, {
      type: "loop",
      perPage: perPage,
      gap: gap,
      perMove: 1,
      focus: "center",
      breakpoints: {
        749: {
          perPage: 1
        },
      },
      pagination: pagination,
      updateOnMove: true
    }).mount();
  }
}

customElements.define("splide-component", SplideComponent);
